module.exports = __webpack_public_path__ + "static/img/IMG_20151103_212400.0c9d49c2.jpg";